import { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Main from '../../../component/Main.jsx';
import Loading from '../../../component/common/loading/Loading.jsx';
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';
import CommonSelect from './CommonSelect09.jsx';

import { useDynamicStyle } from '../../../hooks/useDynamicStyle.js';
import * as Icons from '../../../images/icons/icons_component.js';
import * as Theme from '../../../images/icons/icons_theme';
import { useExcelDownloadHook } from '../../common/excel/useExcelDownloadHook.js';
import useExcelConfirmYn from '../../common/excel/useExcelConfirmYn.js';
import ExcelDownloadReason_layer from '../../../component/common/modal/ExcelDownloadReason_layer.jsx';
import Pagination from '../../../component/common/dataGrid/Pagination.jsx';

export default function BdTrmsHumanSupport() {
    const date = new Date();
    const yyyy = date.getFullYear();
    const today = new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0];

    const [searchParams, setSearchParams] = useState({
        searchFromdate: today,
        searchTodate: today,
        searchEmog: '',
        searchType: '',
    });

    const [dataList, setDataList] = useState([]);
    const [clone, setClone] = useState([]);
    const [checkItems, setCheckItems] = useState([]);
    const [list, setList] = useState([]);
    const [emog, setEmog] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searched, setSearched] = useState(false);
    const [all, setAll] = useState([]);
    const [desc, setDesc] = useState('');

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0,
    });

    const popupPropsInfo = {
        localStorageName: "tableData",
        popupAddress: "/nedis/trmsInfo/trms_humanSupport_popup.do",
    };

    /* ───────────────────────────────────────────────────  상수 & 설정  ─── */
    const DATA_HEAD = ['의료기관명', '전문과목', '성명', '생년월일', '의사면허번호', '의사면허 취득일', '전문의 자격변호', '전문의자격 취득일', '지원전문의 근무시작일', '지원전문의 근무종료일', '근무기간', '국비(당직비/oncall비)', '비고'];

    const DATA_COLUMN = [
        'EMOGCODE',
        'SBJECT_CD',
        'NM',
        'RESI_REG_NO',
        'LCNS_NO',
        'LCNS_DT',
        'SPCLST_NO',
        'SPCLST_REG_DT',
        'SPCLST_BEGIN_DT',
        'SPCLST_END_DT',
        'SPCLST_GAP_DT',
        'LBCST_AT',
        'BIGO'
    ];

    const EXCEL_COLUMN = [
        'EMOGDESC',
        'SBJECT_NM',
        'NM',
        'RESI_REG_NO',
        'LCNS_NO',
        'LCNS_DT',
        'SPCLST_NO',
        'SPCLST_REG_DT',
        'SPCLST_BEGIN_DT',
        'SPCLST_END_DT',
        'SPCLST_GAP_DT',
        'LBCST_AT',
        'BIGO'
    ];

    const API_URL = '/trmsapi/obthrc/human_resource_support_list.do';
    const API_URL_ALL = '/trmsapi/obthrc/human_resource_support_list_all.do';
    const CNT_API_URL = '/trmsapi/obthrc/human_resource_support_list_cnt.do';
    const EXCEL_FILE_NAME = `${desc || '전체'}_지원전문의 인력현황`;

    const COLUMN_OPTIONS = {
        LBCST_AT: [
            { value: '당직비', label: '당직비' },
            { value: 'On-call비', label: 'On-call비' },
            { value: '모두', label: '모두' },
        ],
        DEFAULT_YN: [
            { value: 'N', label: 'N' },
            { value: 'Y', label: 'Y' },
        ],
    };

    /* ───────────────────────────────────────────────────  유틸: 헤더 병합  ─── */
    const singleHeader = !Array.isArray(DATA_HEAD[0]);
    const headerRows = singleHeader ? [DATA_HEAD] : DATA_HEAD;
    const headerRowCount = headerRows.length;
    const colCount = headerRows[0].length;
    const skip = Array.from({ length: headerRowCount }, () => Array(colCount).fill(false));

    const getHeaderSpans = (r, c) => {
        if (skip[r][c]) return null;
        const value = headerRows[r][c];
        let rowspan = 1;
        let colspan = 1;

        // horizontal
        for (let i = c + 1; i < colCount; i++) {
            if (headerRows[r][i] === value) {
                colspan++;
                skip[r][i] = true;
            } else break;
        }

        // vertical
        if (!singleHeader) {
            for (let i = r + 1; i < headerRowCount; i++) {
                let same = true;
                for (let j = 0; j < colspan; j++) {
                    if (headerRows[i][c + j] !== value) {
                        same = false;
                        break;
                    }
                }
                if (same) {
                    for (let j = 0; j < colspan; j++) skip[i][c + j] = true;
                    rowspan++;
                } else break;
            }
        }

        return { rowspan, colspan, value };
    };

    /* ───────────────────────────────────────────────────  유틸: 행 병합  ─── */
    const computeRowSpans = useCallback((list) => {
        const mergeKey = '';
        const spans = list.map(() => ({}));

        let prev = null;
        let start = 0;
        let cnt = 1;

        list.forEach((row, idx) => {
            const cur = row[mergeKey];
            if (cur === prev) {
                spans[start][mergeKey] += 1;
                spans[idx][mergeKey] = 0;
                cnt += 1;
            } else {
                spans[idx][mergeKey] = 1;
                start = idx;
                cnt = 1;
                prev = cur;
            }
        });

        // merge 아닌 컬럼 기본 1
        list.forEach((_, i) => {
            DATA_COLUMN.forEach((k) => {
                if (!(k in spans[i])) spans[i][k] = 1;
            });
        });
        return spans;
    }, []);

    const rowSpans = useMemo(() => computeRowSpans(dataList), [dataList, computeRowSpans]);

    /* ───────────────────────────────────────────────────  API  ─── */
    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const { currentPage, itemsPerPage } = pageInfo;
            const params = { ...searchParams, pageNum: currentPage, displayRowsize: itemsPerPage };
            const { data } = await axios.get(API_URL, { params });
            setDataList(data);
            setClone(data);
            if (CNT_API_URL === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: data.length
                }));
            } else {
                fetchDataCnt();
            }
            setSearched(true);
        } catch (err) {
            console.error('데이터 로딩 오류:', err);
        } finally {
            setLoading(false);
        }
    }, [searchParams, pageInfo]);

    const fetchAllData = async () => {
        try {
            const response = await axios.get(API_URL_ALL,
                { params: searchParams }
            );
            setAll(response.data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(CNT_API_URL,
                { params: searchParams }
            );
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    const callList = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/selectNewSubjList.do', { params: { subType: "spt" } });
            setList(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    const callEmog = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/newHospList.do');
            setEmog(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };
    /* ───────────────────────────────────────────────────  핸들러  ─── */
    const handleInputChange = ({ target: { name, value, type, checked } }) => {
        setSearchParams((prev) => ({ ...prev, [name]: type === 'checkbox' ? (checked ? 'Y' : 'N') : value }));
    };

    const handleAllCheck = (checked) => setCheckItems(checked ? [...clone] : []);

    const handleSingleCheck = (checked, item) => {
        const originalItem = clone.find((row) => row.SN === item.SN);
        if (!originalItem) return;

        setCheckItems((prev) =>
            checked
                ? [...prev, originalItem]
                : prev.filter((i) => i.SN !== item.SN)
        );
    };

    const handleCellChange = (rowIdx, colKey, value) => {
        setDataList((prev) => {
            const next = [...prev];
            const currentRow = next[rowIdx];

            if (currentRow[colKey] === value) return prev;

            let newState = currentRow.stateRows;

            if (newState !== 'inserted') {
                newState = 'updated';
            }

            const updatedRow = {
                ...currentRow,
                [colKey]: value,
                stateRows: newState,
            };

            next[rowIdx] = updatedRow;
            return next;
        });
    };

    const handleAddRow = () => {
        const newRow = {
            SN: Date.now(),
            stateRows: 'inserted',
        };
        setDataList((prevData) => [newRow, ...prevData]);
        setClone((prevData) => [newRow, ...prevData]);
    };

    const handlePageChange = (page) => {
        if (page !== pageInfo.currentPage) setPageInfo((prev) => ({ ...prev, currentPage: page }));
    };

    const onHandlePerPage = (e) => {
        setPageInfo(prev => ({
            ...prev,
            itemsPerPage: parseInt(e.target.value)
        }));
    };

    const search = () => {
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
        setCheckItems([]);
    };

    const convertUpdatedRowsToJson = (updateRows) => {
        const jsonArray = updateRows.map((row) => {
            return {
                newEmogCode: row.EMOGDESC || '',
                emogCode: row.EMOGCODE || '',
                sbjectCd: row.SBJECT_CD || '',
                newSbjectCd: row.SBJECT_NM || '',
                nm: row.NM || '',
                resiRegNo: row.RESI_REG_NO || '',
                lcnsNo: row.LCNS_NO || '',
                lcnsDt: row.LCNS_DT || '',
                spclstNo: row.SPCLST_NO || '',
                spclstRegDt: row.SPCLST_REG_DT || '',
                spclstBeginDt: row.SPCLST_BEGIN_DT || '',
                spclstEndDt: row.SPCLST_END_DT || '',
                endReason: row.END_REASON || '',
                endEtc: '',
                lbcstAt: row.LBCST_AT || '',
                detailSn: row.DETAIL_SN || '',
                bigo: row.BIGO || '',
                flag: row.stateRows === "updated" ? 'U' : 'I'
            };
        });
        console.log(jsonArray);
        return jsonArray; // 또는 jsonArray 그대로 리턴
    };

    const convertDeletedRowsToJson = (checkRows) => {
        const deleted = checkRows.map((row) => ({
            newEmogCode: row.EMOGDESC || '',
            emogCode: row.EMOGCODE || '',
            sbjectCd: row.SBJECT_CD || '',
            newSbjectCd: row.SBJECT_NM || '',
            nm: row.NM || '',
            resiRegNo: row.RESI_REG_NO || '',
            lcnsNo: row.LCNS_NO || '',
            lcnsDt: row.LCNS_DT || '',
            spclstNo: row.SPCLST_NO || '',
            spclstRegDt: row.SPCLST_REG_DT || '',
            spclstBeginDt: row.SPCLST_BEGIN_DT || '',
            spclstEndDt: row.SPCLST_END_DT || '',
            endReason: row.END_REASON || '',
            endEtc: '',
            lbcstAt: row.LBCST_AT || '',
            detailSn: row.DETAIL_SN || '',
            bigo: row.BIGO || '',
            flag: 'D'
        }));
        console.log(deleted);
        return deleted;
    };

    const save = async () => {
        const insertedRows = dataList.filter(row => row.stateRows === 'inserted');
        const updatedRows = dataList.filter(row => row.stateRows === 'updated');
        const iJsonArray = convertUpdatedRowsToJson(insertedRows);
        const uJsonArray = convertUpdatedRowsToJson(updatedRows);
        const deleted = convertDeletedRowsToJson(checkItems);
        const combined = [...iJsonArray, ...uJsonArray, ...deleted];
        const url = '/trmsapi/obthrc/update_hnf_support_data.do';
        saveLogic(combined, url);
    };

    const saveLogic = async (data, url) => {
        const payload = new URLSearchParams({
            emogcode: searchParams.searchEmog,
            hnfData: JSON.stringify(data),
            userId: localStorage.getItem("id"),
        });

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: payload,
            });

            if (!response.ok) {
                throw new Error(`서버 오류: ${response.status}`);
            }

            const resultText = await response.text();
            console.log('저장 결과:', resultText);

            alert('저장이 완료되었습니다.');
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장에 실패했습니다. 관리자에게 문의하세요.');
        }
    };

    const download = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/excel_support_download.do', {
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;

            const disposition = response.headers['content-disposition'];
            const match = disposition && disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            const filename = match ? decodeURIComponent(match[1].replace(/['"]/g, '')) : 'template.xlsx';

            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (error) {
            console.error('다운로드 실패:', error);
        }
    };

    const upload = () => {
        if (searchParams.searchEmog === '') {
            alert("기관을 선택해주세요.");
            return false;
        } else {
            const senData = {
                tableOwner: 'NEMCDBA',
                tableName: 'TRAUMA_HNF_SUPPORT',
                head: ['진료과목 코드', '성명', '생년월일', '의사면허번호', '의사면허 취득일', '지원전문의 자격번호', '지원전문의 자격취득일', '지원전문의 근무시작일', '지원전문의 근무종료일', '근무 종료사유', '국비(당직비/oncall비)', '국비수당 지원시작일', '국비수당 지원종료일', '외상수련기관 인력현황', '외상센터 최초근무일', '비고'],
                emogCode: searchParams.searchEmog,
            }

            let popup = null;

            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(senData));
            popup = window.open(popupPropsInfo.popupAddress, "팝업", "scrollbars=1, resizable=0, width=1200, height=800, top=30, left=30");
        }
    };
    /* ───────────────────────────────────────────────────  셀 렌더링  ─── */
    const renderCell = (row, rowIdx, colKey) => {
        const span = rowSpans[rowIdx][colKey];
        if (span === 0) return null;
        const value = row[colKey] ?? '';

        // 날짜 필드
        if (['LCNS_DT', 'SPCLST_REG_DT', 'SPCLST_BEGIN_DT', 'SPCLST_END_DT'].includes(colKey)) {
            return (
                <td key={colKey} rowSpan={span} className='text-center'>
                    <input type="date" value={value} onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)} />
                </td>
            );
        }

        // 텍스트 필드
        if (['LCNS_NO', 'NM', 'RESI_REG_NO', 'SPCLST_NO', 'BIGO'].includes(colKey)) {
            return (
                <td key={colKey} rowSpan={span}>
                    <input
                        type="text"
                        value={value}
                        className={`h-7 bg-transparent ${colKey === 'BIGO' ? '' : 'text-center outline-none'}`}
                        onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}
                    />
                </td>
            );
        }

        if (['SPCLST_GAP_DT'].includes(colKey)) {
            return (
                <td key={colKey} rowSpan={span}>
                    <input
                        type="text"
                        value={value}
                        className='h-7 outline-none bg-transparent text-center'
                        onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}
                        readOnly
                        disabled='disabled'
                    />
                </td>
            );
        }

        if (['EMOGCODE'].includes(colKey)) {
            return (
                <td key={colKey} rowSpan={span}>
                    <select value={value} onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}>
                        {emog.map((o) => (
                            <option key={o.EMOGCODE} value={o.EMOGCODE} className='text-center'>
                                {o.EMOGDESC}
                            </option>
                        ))}
                    </select>
                </td>
            )
        }

        if (['SBJECT_CD'].includes(colKey)) {
            return (
                <td key={colKey} rowSpan={span}>
                    <select value={value} onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}>
                        {list.map((o) => (
                            <option key={o.CD} value={o.CD} className='text-center'>
                                {o.CD_NM}
                            </option>
                        ))}
                    </select>
                </td>
            )
        }

        // 옵션 셀렉트
        const opts = COLUMN_OPTIONS[colKey] || COLUMN_OPTIONS.DEFAULT_YN;
        return (
            <td key={colKey} rowSpan={span}>
                <select value={value} onChange={(e) => handleCellChange(rowIdx, colKey, e.target.value)}>
                    {opts.map((o) => (
                        <option key={o.value} value={o.value} className='text-center'>
                            {o.label}
                        </option>
                    ))}
                </select>
            </td>
        );
    };
    useEffect(() => {
        search();
        callList();
        callEmog();
        fetchAllData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [pageInfo.currentPage]);

    const perPageOptions = Array.from({ length: 10 }, (_, i) => {
        const perPage = (i + 1) * 10;
        return (
            <option key={perPage} value={perPage}>
                -- {perPage}건 씩 조회 --
            </option>
        );
    });

    const { fontColor, lightBackColor, borderColorGray } = useDynamicStyle();

    const confirmYn = useExcelConfirmYn();
    const path = decodeURIComponent(useLocation().pathname);
    const { isModalOpen, isDown, updateParams, openConfModal, closeModal, handleUpdateInputChange, setIsDown } = useExcelDownloadHook();

    return (
        <Main>
            {/* 검색 영역 */}
            <ExcelDownloadReason_layer
                isModalOpen={isModalOpen}
                closeModal={closeModal}
                updateParams={updateParams}
                handleUpdateInputChange={handleUpdateInputChange}
                searchParams={searchParams}
                route={path}
                excelFileName={`${EXCEL_FILE_NAME}.xlsx`}
                setIsDown={setIsDown}
            />
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="29%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <CommonSelect
                            searchParams={searchParams}
                            handleInputChange={handleInputChange}
                            flag="Y"
                            setDesc={setDesc}
                        />
                        <tr>
                            <th>엑셀 업로드</th>
                            <td className='flex'>
                                <button onClick={upload} className='search_btn bg_tr_primary'><Icons.Upload16w />엑셀업로드</button>
                                <button onClick={download} className='excel_form_down'><Theme.Download16 className='co_black' />양식다운로드</button>
                            </td>
                            <th>전체정보현황</th>
                            <td>
                                <ExcelDownload
                                    excelHead={DATA_HEAD}
                                    excelData={searchParams.searchEmog !== 'non' ? clone : all}
                                    searched={searched}
                                    dataCode={EXCEL_COLUMN}
                                    excelFileName={EXCEL_FILE_NAME}
                                    confirmYn={confirmYn}
                                    openConfModal={openConfModal}
                                    isDown={isDown}
                                />
                            </td>
                            <th>전문과목</th>
                            <td>
                                <select
                                    id='searchType'
                                    name='searchType'
                                    value={searchParams.searchType}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    {list.map(hosp => (
                                        <option value={hosp.CD} key={hosp.CD}>{hosp.CD_NM}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* 버튼 영역 */}
            <div className="search_btn_wrapper">
                <span className='total_items'>전체&nbsp;<strong className={fontColor}>{pageInfo.totalItems}</strong>건</span>
                <div className='btn_container'>
                    <select
                        name="itemsPerPage"
                        value={pageInfo.itemsPerPage}
                        className='page_select'
                        onChange={onHandlePerPage}
                    >
                        {perPageOptions}
                    </select>
                    <button onClick={search} disabled={loading} className='search_btn bg_tr_primary'><Icons.Search16w />조회</button>
                    <button onClick={handleAddRow} disabled={dataList.length === 0 || loading} className='search_btn bg_co_black'><Icons.AddCircle16w />추가</button>
                    <button onClick={save} disabled={dataList.length === 0 || loading} className='search_btn bg_co_black'><Icons.Save16w />저장</button>
                    <button onClick={save} disabled={dataList.length === 0 || loading} className='search_btn bg_co_black'><Icons.DeleteCircle16w />삭제</button>
                </div>
            </div>

            {loading ? <Loading />
                : (
                    <div className='data_grid_container'>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                        <div className={`data_list_table ${searched ? 'grid-animation' : ''}`}>
                            <table>
                                <thead className='middle'>
                                    {headerRows.map((row, rIdx) => (
                                        <tr key={rIdx}>
                                            {rIdx === 0 && (
                                                <th rowSpan={headerRowCount}>
                                                    <div className='flex justify-center'>
                                                        {dataList.length > 0 && checkItems.length === dataList.length ?
                                                            <Icons.CheckOk className='cursor-pointer' onClick={() => handleAllCheck(false)} />
                                                            :
                                                            <Icons.CheckNon className='cursor-pointer' onClick={() => handleAllCheck(true)} />
                                                        }
                                                    </div>
                                                </th>
                                            )}
                                            {row.map((col, cIdx) => {
                                                const span = getHeaderSpans(rIdx, cIdx);
                                                if (!span) return null;
                                                const { rowspan, colspan, value } = span;
                                                return (
                                                    <th key={`${rIdx}-${cIdx}`} rowSpan={rowspan} colSpan={colspan}>
                                                        {value}
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                </thead>
                                <tbody>
                                    {dataList.length === 0 ? (
                                        <tr>
                                            <td colSpan={1000} className='empty_box'>
                                                <span className={`data_empty ${lightBackColor}`}>
                                                    {searched ? <Icons.EmptySalgu /> : <Icons.NullSalgu />}
                                                    {searched ? '해당하는 데이터가 없습니다.' : '검색 버튼을 눌러 데이터를 조회하세요.'}
                                                </span>
                                            </td>
                                        </tr>
                                    )
                                        :
                                        (dataList.map((row, rowIdx) => {
                                            const isChecked = checkItems.some((i) => i.SN === row.SN);
                                            const oe = !row?.SPCLST_END_DT && (row?.AGREE_DT === undefined || parseInt(yyyy) - parseInt(row?.AGREE_DT?.substr(0, 4)) >= 9) ? "orange !important" : rowIdx % 2 === 0 ? lightBackColor : '';
                                            return (
                                                <tr key={row.SN || rowIdx} className={oe}>
                                                    <td>
                                                        <div className='flex justify-center'>
                                                            {isChecked ?
                                                                <Icons.CheckOk className='cursor-pointer' onClick={() => handleSingleCheck(false, row)} />
                                                                :
                                                                <Icons.CheckNon className='cursor-pointer' onClick={() => handleSingleCheck(true, row)} />
                                                            }
                                                        </div>
                                                    </td>
                                                    {DATA_COLUMN.map((colKey) => renderCell(row, rowIdx, colKey))}
                                                </tr>
                                            );
                                        }))}
                                </tbody>
                            </table>
                        </div>
                        <hr className='mr-1-1 co_border_gray' />
                        {dataList.length > 0 && pageInfo.paginationTF && (
                            <div>
                                <Pagination paginationInfo={{ ...pageInfo, onPageChange: handlePageChange }} />
                            </div>
                        )}
                    </div>
                )}
        </Main>
    );
}
